<template>
  <div>
    <div>
      <div class="styled-radio-container styled-radio-container--ou-donation row">
        <div class="radio-part">
          <input
            id="oneTime"
            type="radio"
            class="frequency"
            :checked="!monthly && getValue('amount') === '1000'"
            @click="
              setValue('dayOfMonth', null);
              setValue('periodMonths', null);
              setValue('amount', '1000');
            "
          />
          <FormLabel for="oneTime">$1,000 Single Donation</FormLabel>
        </div>
        <div class="radio-part">
          <input
            id="monthly"
            type="radio"
            class="frequency"
            :checked="monthly && getValue('amount') === '83.33'"
            @click="
              setValue('dayOfMonth', '' + new Date().getDate());
              setValue('amount', '83.33');
              setValue('periodMonths', '12');
            "
          />
          <FormLabel for="monthly">$83.33 Monthly Donation</FormLabel>
        </div>
      </div>
    </div>
    <FormRow class="monthly-note" v-if="monthly && showMsg">
      <div>
        Your donation will be made today and on the <strong>{{ monthDay }}</strong> of
        each following month using the payment method selected. You may change or cancel
        this amount at any time. <br /><br />
      </div>
    </FormRow>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, type PropType, ref, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  props: {
    showMsg: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const { form, setValue, getValue } = usePaymentForm();

    return {
      monthly: computed(() => !!form.value.dayOfMonth),
      setValue,
      getValue,
      monthDay: computed(() => {
        const i = +form.value.dayOfMonth!;

        const j = i % 10,
          k = i % 100;
        if (j == 1 && k != 11) {
          return i + "st";
        }
        if (j == 2 && k != 12) {
          return i + "nd";
        }
        if (j == 3 && k != 13) {
          return i + "rd";
        }
        return i + "th";
      }),
    };
  },
});
</script>
<style scoped lang="scss">
.monthly-note {
  font-size: 13px;
  line-height: 1.4;
  margin-top: 10px;
  display: flex;
  align-items: center;

  .month-limit {
    margin-right: 20px;
    min-width: 110px;
  }
}
.styled-radio-container--ou-donation.styled-radio-container {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .radio-part {
    padding: 0px 5px;
    line-height: 1;
    @media (max-width: 720px) {
      width: 50%;
      margin-bottom: 10px;
    }
    @media (min-width: 720px) {
      min-width: 33.3%;
      flex: 1;
      padding-right: 10px;
      padding-left: 0;
      max-width: 33.3%;
      margin-bottom: 10px;
    }
  }
  input[type="radio"] {
    height: 0;
    top: 20px;
    position: relative;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    padding: 15px;
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin-top: -15px;
    display: block;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  input[type="radio"]:checked + label {
    background: $color-blue;
    color: white;
  }
  label:hover {
    background: #e9f0f7;
  }
}
</style>
